import { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import { Calendar } from "../../../components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../../../components/ui/popover";
import { isoDate, parseIso } from "../../../booking/utils";

export const ListInput = ({ value, onChange, testid, placeholder }) => {
  const [raw, setRaw] = useState((value || []).join(", "));
  useEffect(() => { setRaw((value || []).join(", ")); }, [value]);
  const commit = () => onChange(raw.split(",").map((x) => x.trim()).filter(Boolean));
  return <Input value={raw} onChange={(e) => setRaw(e.target.value)} onBlur={commit} placeholder={placeholder} data-testid={testid} />;
};

export const DateField = ({ value, onChange, testid }) => (
  <div className="flex gap-2">
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className="flex-1 justify-start font-normal" data-testid={testid}>
          <CalendarDays size={15} className="mr-2" /> {value || "Not set"}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" weekStartsOn={1} selected={value ? parseIso(value) : undefined}
          onSelect={(d) => onChange(d ? isoDate(d) : null)} />
      </PopoverContent>
    </Popover>
    {value && <Button variant="ghost" onClick={() => onChange(null)} data-testid={`${testid}-clear`}>Clear</Button>}
  </div>
);
